import React, { useState, useEffect } from "react";
import SignUp from "../signIn";
import ComponenptsFive from "../compo-5";
import ComponentSix from "../compo-6";
import { animated, config } from "react-spring";
import Carousel from "react-bootstrap/Carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "./style.css";
function Rendering33() {
  const [show, setshow] = useState(true);
  const [show2, setshow2] = useState(false);
  const [show3, setshow3] = useState(false);

  const createLoop = () => {
    if (show) {
      setshow(false);
      setshow2(true);
      setshow3(false);
    } else if (show2) {
      setshow(false);
      setshow2(false);
      setshow3(true);
    } else if (show3) {
      setshow(true);
      setshow2(false);
      setshow3(false);
    }
  };

  useEffect(() => {
    setTimeout(createLoop, 4000);
  }, [show, show2, show3]);

  return (
    <div>
      <Carousel slide={false} indicators={false}>
        <Carousel.Item>
          {show && <SignUp />}
          {show2 && <ComponenptsFive />}
          {show3 && <ComponentSix />}
        </Carousel.Item>
      </Carousel>

      {/* {show && (
        <animated.div
          style={{
            position: "absolute",
            width: "100%",
            marginTop: "2rem",
            opacity: ".2",
            zIndex: -2,

            // boxShadow: "1px 2px 9px #F4AAB9",
            // opacity: opacity.to({ range: [0.0, 1.0], output: [0, 1] }),
          }}
        >
          <SignUp />
        </animated.div>
      )}
      {show2 && (
        <animated.div
          style={{
            position: "absolute",
            width: "100%",
            marginTop: "2rem",
            opacity: ".9",
            zIndex: -1,

            // boxShadow: "1px 2px 9px #F4AAB9",
            // opacity: opacity.to({ range: [0.0, 1.0], output: [0, 1] }),
          }}
        >
          <ComponenptsFive />
        </animated.div>
      )}
      {show3 && (
        <animated.div
          style={{
            position: "absolute",
            width: "100%",
            marginTop: "2rem",
            opacity: "1",
            zIndex: 1,

            // boxShadow: "1px 2px 9px #F4AAB9",
            // opacity: opacity.to({ range: [0.0, 1.0], output: [0, 1] }),
          }}
        >
          <ComponentSix />
        </animated.div>
      )} */}
    </div>
  );
}

export default Rendering33;
